import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

export interface PageHeaderProps {
  title?: React.ReactNode;
  subTitle?: React.ReactNode;
  /** Đặt subTitle cùng hàng với title (mặc định: xếp dưới). */
  subTitleInline?: boolean;
  onBack?: () => void;
  extra?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  backIcon?: React.ReactNode;
  ghost?: boolean;
  breadcrumb?: React.ReactNode;
  tags?: React.ReactNode;
  footer?: React.ReactNode;
  [key: string]: any;
}

export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subTitle,
  subTitleInline = false,
  onBack,
  extra,
  style,
  className,
  backIcon,
}) => (
  <Box
    className={['ant-page-header', className].filter(Boolean).join(' ')}
    sx={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1,
      mb: 2,
      pb: 1,
      borderBottom: '1px solid #f0f0f0',
      ...(style as object),
    }}
  >
    <Box
      className="ant-page-header-heading"
      sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flex: 1, minWidth: 0 }}
    >
      {onBack && (
        <IconButton size="small" onClick={onBack} sx={{ flexShrink: 0, p: 0.35 }}>
          {backIcon ?? <ArrowBackIcon sx={{ fontSize: 18 }} />}
        </IconButton>
      )}
      <Box
        sx={{
          minWidth: 0,
          flex: 1,
          display: 'flex',
          flexDirection: subTitleInline ? 'row' : 'column',
          flexWrap: subTitleInline ? 'wrap' : 'nowrap',
          alignItems: subTitleInline ? 'center' : 'stretch',
          justifyContent: subTitleInline ? 'flex-start' : 'center',
          gap: subTitleInline ? 0.75 : 0,
        }}
      >
        {title != null && (
          <Typography
            variant="h6"
            component="div"
            sx={{ fontWeight: 600, lineHeight: 1.25, m: 0, flexShrink: 0, fontSize: '1rem' }}
          >
            {title}
          </Typography>
        )}
        {subTitle != null &&
          (subTitleInline ? (
            <Box
              component="div"
              sx={{
                display: 'inline-flex',
                alignItems: 'center',
                minWidth: 0,
                flex: '1 1 220px',
                color: 'text.secondary',
                fontSize: '0.875rem',
              }}
            >
              {subTitle}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
              {subTitle}
            </Typography>
          ))}
      </Box>
    </Box>
    {extra && (
      <Box sx={{ display: 'flex', gap: 1, alignItems: 'center', flexShrink: 0 }}>{extra}</Box>
    )}
  </Box>
);

export default PageHeader;
